import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Sort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SortTableDataService } from "app/main/shared/services/sort-table-data.service";
import {
  tatDescription,
  deliveryZoneEDescription
} from "app/main/shared/ts/description";
import { b2bZones, zones } from "app/main/shared/ts/courierRates";

@Component({
  selector: "app-table-view",
  templateUrl: "./table-view.component.html",
  styleUrls: ["./table-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableViewComponent {
  @Input() courierPrices: any[] = [];
  @Input() courierPartnerForm: FormGroup;
  @Output() courierPartnerValue = new EventEmitter();
  @Output() showShippingChargeInfo = new EventEmitter();

  b2bCourierZones = b2bZones;
  zones = zones;

  tatDescription = tatDescription;
  deliveryZoneEDescription = deliveryZoneEDescription;

  // Rate Table
  rateTableHeader = [
    // "select",
    // "photo",
    "courierName",
    "courierService",
    "zone",
    "shippingCharge",
    "chargedWeight",
    "tat"
  ];

  dataSource = new MatTableDataSource([]);

  constructor(
    private _sortTableDataService: SortTableDataService,
    private _cd: ChangeDetectorRef
  ) {}

  ngOnChanges() {
    this.dataSource.data = this.courierPrices;
    this._sortTableDataService.originalDataSource = this.courierPrices.slice();
  }

  shippingChargeInfo(details, heading) {
    this.showShippingChargeInfo.emit({ details, heading });
  }

  sortData(sort: Sort) {
    this._sortTableDataService.sortTableData(sort, this.dataSource);
  }

  markForCheck() {
    this._cd.markForCheck();
  }
}
